module.exports = __webpack_public_path__ + "img/blog-16.ecd25954.webp";